import { useSelector } from "react-redux";
import { DisruptionApp } from "@b2bportal/core-disruption";
import { FlightPostBookingSelectors } from "@b2bportal/core-flights";
import { fetchItinerary, fetchTripDetails } from "@b2bportal/core-flights";
import { Page } from "@b2bportal/core-ui";
import { useFintechExercisePage } from "../../../../../src/utils/hooks";
import { FLIGHT_ITINERARY_PAGE_PATH } from "../../../../utils/paths";

export const UniversalDisruptionExercise = () => {
  const { itinerary, backToItineraryDetailPage } = useFintechExercisePage(
    FlightPostBookingSelectors.getSelectedFlightItinerary,
    FLIGHT_ITINERARY_PAGE_PATH,
    ""
  );

  const airportMap = useSelector(FlightPostBookingSelectors.getAirports);

  return (
    <Page>
      <DisruptionApp
        disruptedFlight={itinerary}
        onContactSupport={null}
        handleExerciseCompleted={backToItineraryDetailPage}
        displayExternalLinkAsModal={true}
        airports={airportMap}
        // TODO: when rebooking tool is available, set this value based on kill switch
        disruptionSelfServeRebook={false}
        fetchItinerary={fetchItinerary}
        fetchTripDetails={fetchTripDetails}
      />
    </Page>
  );
};
